import { counted } from '../plural';
import type { Messages } from '../shape';

export const claude = {
  connect: {
    title: 'Подключить Claude',
    titleDone: 'Claude подключён',
    subtitle: 'Хранилище, устроенное как память Claude',
    subtitleDone: 'Одно хранилище, которое этот сервер может прочитать',

    lede:
      'Создаётся хранилище с готовой структурой — context, projects, skills, memory и ' +
      'inbox — и его ключ уходит этому серверу, чтобы Claude мог читать и писать через ' +
      'коннектор.',

    warnLead: 'Этот сервер сможет прочитать это хранилище.',
    warnBody:
      'Каждое имя папки, каждый заголовок и каждый текст. Это единственное место в Shelf, ' +
      'где так бывает, и именно оно делает коннектор возможным. Всё, что Claude здесь прочитает, ' +
      'уходит и наружу — в Anthropic. Других ваших хранилищ это не касается: ключей от ' +
      'них у сервера нет и получить их он не может.',

    acceptKey: 'Я понимаю, что ключ от этого хранилища будет у сервера, и принимаю это.',
    acceptNoSecrets:
      'Я не буду держать здесь пароли, ключи, коды восстановления и личные данные других людей.',

    nameLabel: 'Имя хранилища',
    nameInitial: 'Claude',

    mayDo: 'Что Claude может делать',
    editor: 'Читать и писать',
    editorHint: 'Claude ведёт собственную память и заметки по проектам.',
    viewer: 'Только читать',
    viewerHint: 'Claude может что-то посмотреть, но никогда не пишет.',

    creating: 'Создаём…',
    create: 'Создать и подключить',

    halfMade: (why: string) =>
      `Хранилище создано, но подключить его не удалось. ${why} Оно есть в меню хранилищ — ` +
      'подключите его оттуда заново или удалите.',

    firstClient: 'первый клиент',

    footerOnce: 'Токен показывается один раз',
    footerRevocable: 'Отозвать можно в меню хранилища',
    footerNothing: 'Ничего не создано',

    off: {
      lede:
        'Этот сервер не настроен на коннектор, поэтому созданное здесь хранилище не удалось ' +
        'бы подключить к Claude. Ничего не создано.',
      note:
        'По умолчанию он выключен: это единственная возможность, которая отдаёт серверу ключ. ' +
        'Чтобы включить, нужны три настройки и перезапуск.',
      section: 'Что задать',
      secretNote: (path: string) => `не короче 32 символов, и никогда в ${path}`,
      urlNote: 'ровно тот адрес, который получит Claude',
      noFallback:
        'У секрета нигде нет запасного значения, в том числе локально: сгенерированный при ' +
        'старте, он сделал бы все уже сохранённые ключи коннектора нечитаемыми после первого ' +
        'же перезапуска.',
    },

    done: {
      lede: (notes: number, folders: number) =>
        `— ${counted(notes, ['заметка', 'заметки', 'заметок'])} в ` +
        `${counted(folders, ['папке', 'папках', 'папках'])}, и ключ от него теперь есть у ` +
        'этого сервера.',
      urlSection: 'Адрес коннектора',
      // «Claude Desktop» и «Claude Code» названы описательно: проверка словаря знает список
      // имён, которые остаются латиницей, и «Desktop» с «Code» в него не входят.
      localNote:
        'Приложение Claude обращается к коннектору из внешней сети, поэтому адрес на этой ' +
        'машине для него недоступен. Из командной строки — можно, прямо отсюда:',
      credentialSection: 'Токен',
      credentialNote:
        'Вставляйте его целиком, вместе со схемой. Он показывается один раз — сервер хранит ' +
        'только его хеш, поэтому потерянный токен не восстанавливают, а выпускают заново.',
      fingerprintSection: 'Отпечаток ключа',
      undoSection: 'Как это отменить',
      undoRemove: 'Уберите коннектор из участников этого хранилища.',
      undoRotate:
        'Потом сделайте ротацию ключа хранилища: удаление останавливает новые чтения, а уже ' +
        'увиденный ключ обесценивает именно ротация.',
    },
  },

  view: {
    connected: (role: string, fingerprint: string) =>
      `Подключён как ${role.toLowerCase()} · ${fingerprint}`,
    noConnector: 'На этом хранилище нет коннектора — Claude его не видит',
    instructions: 'Инструкции',
    reading: (covered: number, total: number) =>
      `Читаем хранилище — открыто ${covered} из ` +
      `${counted(total, ['заметки', 'заметок', 'заметок'])}.`,

    projects: 'Проекты',
    newProject: 'Новый проект',
    projectName: 'Имя проекта',
    noProjects: 'В работе ничего нет. Проект — это папка, в которой лежит CLAUDE.md.',

    changed: 'Что изменил Claude',
    noChanges: 'Пока пусто. Всё, что пишет коннектор, появляется сначала здесь.',

    memory: 'Память',
    noMemory: 'Журнала пока нет. Месяцы лежат в memory/ файлами вида 2026-08.md.',
    entries: (count: number) => counted(count, ['запись', 'записи', 'записей']),

    skills: 'Скиллы',
    newSkill: 'Новый скилл',
    skillName: 'Имя скилла',
    noSkills:
      'Ни одного не написано. Скилл — это порядок действий, который стоит повторять в точности.',
    notWritten: 'ещё не написан',

    context: 'Контекст',
    noContext: 'Постоянных фактов нет. Это то, что Claude читает, прежде чем ответить.',
    blank: 'пусто',

    inbox: 'Входящие',
    elsewhere: 'Вне пяти областей',
    root: 'корень',

    fresh: 'новый',
    unfilled: 'Это ещё никто не заполнил.',
    noSummary: 'Без описания.',
    notes: (count: number) => counted(count, ['заметка', 'заметки', 'заметок']),
    decided: (count: number) => counted(count, ['решение', 'решения', 'решений']),
    done: (count: number) => `сделано ${count}`,
  },

  consent: {
    title: 'Подключение к Shelf',
    checking: 'Выясняем, кто спрашивает…',
    someClient: 'Клиент MCP',
    asking: (client: string) => `${client} просит доступ к одному из ваших хранилищ`,

    nothing: 'Одобрять здесь нечего',
    linkIncomplete: 'В этой ссылке не хватает нужных данных.',
    methodRefused: 'Клиент запросил способ проверки, который этот сервер не принимает.',
    clientUnknown: 'Этот клиент не зарегистрирован на сервере.',

    noneBefore: 'Ни у одного вашего хранилища ещё нет коннектора. Заведите его в меню хранилища —',
    menuItem: 'Подключить Claude…',
    noneAfter: '— и вернитесь по этой ссылке.',

    ledeOne:
      'Одобрение даёт этому клиенту читать хранилище ниже через коннектор и писать в него ' +
      'там, где коннектору это позволено. Больше ничего в вашей учётной записи клиент не ' +
      'получит.',
    ledeMany:
      'Одобрение даёт этому клиенту читать выбранное вами хранилище через коннектор и писать ' +
      'в него там, где коннектору это позволено. Больше ничего в вашей учётной записи клиент ' +
      'не получит.',

    vaultSection: 'Хранилище',
    notes: (count: number) => counted(count, ['заметка', 'заметки', 'заметок']),

    returning: 'Куда вернётся',
    addressNote:
      'Проверьте этот адрес. Именно туда клиент получит код, а локальный адрес принадлежит ' +
      'тому, что слушает его на этой машине.',

    footerKey: 'Ключ от этого хранилища у сервера уже есть',
    deny: 'Отказать',
    approving: 'Одобряем…',
    allow: 'Разрешить',
  },
} satisfies Messages['claude'];
